<template>
  <div class="common-select pointer">
    <el-dropdown @command="select" trigger="click">
      <span class="el-dropdown-link font-main">
        {{ text }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu v-if="type === 'time'" slot="dropdown">
        <el-dropdown-item :class="{ 'is-active': !selectedOption }">
          {{ defaultText }}
        </el-dropdown-item>
        <el-dropdown-item
          :class="{ 'is-active': item === selectedOption }"
          v-for="item in timeOptions"
          :key="item"
          :command="item"
        >
          {{ item }}
        </el-dropdown-item>
      </el-dropdown-menu>
      <el-dropdown-menu v-else slot="dropdown">
        <el-dropdown-item :class="{ 'is-active': !selectedOption }">
          {{ defaultText }}
        </el-dropdown-item>
        <el-dropdown-item
          :class="{ 'is-active': item.value === selectedOption }"
          v-for="item in options"
          :key="item.value"
          :command="item.value"
        >
          {{ item.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { timeArr } from "./static"

export default {
  name: "common-select",
  props: {
    type: {
      // time、default
      type: String,
      default: "default"
    },
    options: {
      type: Array,
      default: () => [{ label: "选项1", value: 1 }]
    },
    label: String
  },
  computed: {
    defaultText() {
      return this.label || "所有类型"
    },
    text() {
      if (this.type === "time") {
        return this.selectedOption || this.defaultText
      }
      return this.options.find(o => o.value === this.selectedOption)?.label || this.defaultText
    }
  },
  data() {
    return {
      selectedOption: null,
      timeOptions: timeArr.map(t => t.label)
    }
  },
  methods: {
    select(option) {
      this.selectedOption = option
      if (this.timeOptions.includes(option)) {
        this.$emit("select", timeArr.find(t => t.label === option)?.value)
      } else {
        this.$emit("select", option)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dropdown-menu__item {
    &:focus,
    &:hover,
    &.is-active {
      background-color: $color-bg-select;
      color: $color-font-title;
    }
  }
}
</style>
